import React, { useEffect, useState } from "react";
import Header from "../Header";
import { FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, 
  TextField, Paper, Box, Button, Typography } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { useNavigate, useParams } from "react-router-dom";
import HelpIcon from '@mui/icons-material/Help';

export default function Register() {

  const navigate = useNavigate()
  const params = useParams()

  const [values, setValues] = useState({
    firstName: "",
    lastName: "",
    bandName: "",
    username: "",
    emailAddress: "",
    password: "",
    confirmPassword: "",
    showPassword: false
  })

  const [userExists, setUserExists] = useState(false)
  const [regDisabled, setRegDisabled] = useState(true)

  async function checkUsername(e){
    e.preventDefault()
    const username = params.username

    const response = await fetch(`https://the-paper-pusher.herokuapp.com/checkUsername/${values.username}`)
    if (!response.ok) {
      const message = `An error occurred: ${response.statusText}`
      window.alert(message)
      return
    }
    const userCount = await response.json()
    if(userCount === 0){
      setUserExists(false)
      setRegDisabled(false)
    } else if(userCount === 1){
      setUserExists(true)
      setRegDisabled(true)
    }
  }
  

  async function createUser(e){
    e.preventDefault()
      const newUser = { ...values }

    await fetch("https://the-paper-pusher.herokuapp.com/createUser", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(newUser)
    })
    .catch(error=>{
      window.alert(error)
      return
    })
    navigate("/")
  }

  const handleChange = (e) => {
    setValues(
      { ...values, 
        [e.target.name]: e.target.value 
      });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <div className="register-form">
      <Header />
      <Paper elevation={3} sx={{maxWidth: 820, margin: '0 auto'}}>
        <h3 className="form-heading">Register</h3>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', maxWidth: 700, margin: '0 auto' , justifyContent: 'center'}}>

        <div className="register-inputs">
          <TextField
            required
            sx={{marginBottom: 2}}
            name="firstName"
            id="outlined-required"
            label="First Name"
            onChange={handleChange}
            />
          
          <TextField
            required
            sx={{marginBottom: 2}}
            name="lastName"
            id="outlined-required"
            label="Last Name"
            onChange={handleChange}
            />

          <TextField
            required
            sx={{marginBottom: 2}}
            name="bandName"
            id="outlined-required"
            label="Artist/ Band Name"
            onChange={handleChange}
            />
          <div className="username-check-btn">
            <TextField
              error={userExists? true : false}
              helperText={userExists ? "Username already exists":""}
              required
              sx={{marginBottom: 0}}
              name="username"
              id="outlined-required"
              label="Username"
              onChange={handleChange}
            /> 
            <Button sx={{justifySelf: 'center'}} onClick={checkUsername}>Check if <Typography sx={{fontSize: 'inherit', marginLeft: 0.5, color: userExists ? 'inherit' : 'green'}}>available</Typography></Button> 
          </div>
          <TextField
            required
            sx={{marginBottom: 2}}
            name="emailAddress"
            id="outlined-required"
            label="Email Address"
            onChange={handleChange}
          />

        <FormControl sx={{marginBottom: 2}} variant="outlined">
          <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
          <OutlinedInput
            name="password"
            id="outlined-adornment-password"
            type={values.showPassword ? 'text' : 'password'}
            value={values.password}
            onChange={handleChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {values.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
        <FormControl sx={{marginBottom: 2}} variant="outlined">
          <InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
          <OutlinedInput
            name="confirmPassword"
            id="outlined-adornment-password"
            type={values.showPassword ? 'text' : 'password'}
            value={values.confirmPassword}
            onChange={handleChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {values.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Confirm Password"
          />
        </FormControl>

        </div>

        </Box>

        <Button onClick={createUser} disabled={regDisabled}>Register</Button>
        <div className="already-register">
          <Typography>
            Already have an account? 
            <Button onClick={() => navigate("/")}>Log in</Button>
          </Typography>
          <IconButton onClick={()=> navigate("/help")}><HelpIcon /><Typography sx={{marginLeft: '0.5em'}}>Learn more</Typography></IconButton>
        </div>
        

      </Paper>
      
    </div>
  ) 
}